import { useMemo } from "react";
import { Badge, Text } from "@mantine/core";
import {
  formatAnalysisCategory,
  type AnalysisCategory,
} from "@deep-consulting-solutions/observation-ui";

const KNOWN_CATEGORIES: ReadonlyArray<AnalysisCategory> = [
  "bug",
  "ux_friction",
  "feature_request",
  "question",
  "data_issue",
];

interface ObservationCategoryBadgeProps {
  category: string | null;
}

/**
 * Renders an AI-assigned category, falling back to an em dash when the
 * observation has not been analysed or carries a category this build of the
 * observation-ui package doesn't recognise.
 */
export function ObservationCategoryBadge({
  category,
}: ObservationCategoryBadgeProps) {
  const known = useMemo(
    () =>
      category && (KNOWN_CATEGORIES as readonly string[]).includes(category)
        ? (category as AnalysisCategory)
        : null,
    [category]
  );

  const formatted = useMemo(
    () => (known ? formatAnalysisCategory(known) : null),
    [known]
  );

  if (!formatted) {
    return (
      <Text size="xs" c="dimmed">
        —
      </Text>
    );
  }

  return (
    <Badge color={formatted.color} variant="light" size="sm">
      {formatted.label}
    </Badge>
  );
}

export default ObservationCategoryBadge;
